export class ReligiousTime {
    public CityName ?: String
    public CountryCode: String
    public CountryName: String
    public CityLName: String
    public CountryLName: String
    public CountryAlpha2: String
    public TimeZone: String
    public Imsaak?: String =''
    public Sunrise: String
    public SunriseDT: String
    public Noon: String
    public Sunset: String
    public Maghreb: String
    public Midnight: String
    public Today: String
    public TodayQamari: String
    public TodayGregorian: String
    public DayLenght: String
    public SimultaneityOfKaaba: String
    public SimultaneityOfKaabaDesc: String
}


